import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

const SUBTITLE_TEXT =
  "Pennsylvania has repeatedly changed how it counts coronavirus deaths since March and has often been late in reporting new deaths. That’s led to unusual spikes in publicly available data that has, at times, made it difficult to understand how the state’s death rate is trending.";

const FOOTNOTE_TEXT =
  "Reported death data is based on statistics published daily by the Pa. Department of Health and collected by Spotlight PA/The Philadelphia Inquirer between March to September 2020. Occurred death data is based on Pa. Department of Health statistics collected on Sept. 22, 2020.";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header
            headline="Pennsylvania's erratic death data"
            subtitle={SUBTITLE_TEXT}
          />
          <Body data={data} />
          <Footer
            footnote={FOOTNOTE_TEXT}
            byline="Daniel Simmons Ritchie"
            source="Pa. Department of Health"
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
